import PreviewExpandable from 'app/features/questionnaires/components/PreviewExpandable';
import { useSelector } from 'react-redux';
import { selectQuestionnaireRoutes } from '../../routes/slice';
import PreviewDeductions from './Deductions/preview';
import PreviewTaxesPaid from './TaxesPaid/preview';
import PreviewTaxesPaidSpouse from './TaxesPaidSpouse/preview';

export interface IPreviewTaxesDeductionsProps {}

export default function PreviewTaxesDeductions(
  props: IPreviewTaxesDeductionsProps,
) {
  const routes = useSelector(selectQuestionnaireRoutes).routes;

  return (
    <>
      <PreviewExpandable title="Tax Deductions">
        {routes.taxesDeductions.deductions && <PreviewDeductions />}
        {routes.taxesDeductions.taxesPaid && <PreviewTaxesPaid />}
        {routes.taxesDeductions.taxesPaidSpouse && <PreviewTaxesPaidSpouse />}
      </PreviewExpandable>
    </>
  );
}
